import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MaintenanceService } from './interceptors/maintenance.service';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'inruilmodule';

  constructor(
    private maintenanceService: MaintenanceService,
    private router: Router,
    private swUpdate: SwUpdate,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.maintenanceService.isMaintenance$.subscribe((isMaintenance) => {
      if (isMaintenance) {
        // Redirect to maintenance page if not already there
        if (this.router.url !== '/maintenance') {
          this.router.navigate(['/maintenance']);
        }
      }
    });

    // Check for service worker updates
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates
        .pipe(
          filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
        )
        .subscribe(() => {
          this.showUpdateNotification();
        });
    }
  }

  private showUpdateNotification() {
    const snackBarRef = this.snackBar.open(
      'Er is een nieuwe frontend versie beschikbaar',
      'Herladen',
      {
        duration: 0, // Keep it open until action is taken
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      }
    );

    snackBarRef.onAction().subscribe(() => {
      window.location.reload();
    });
  }
}